import { useToastContext } from "../../contexts/ToastContext";
import { enviroment } from "../../enviroment";
import { User } from "../../core/entities/user";

const API_URL = enviroment.apiUrl;
const AUTH_URL = enviroment.authUrl;

export function useAuthHttpClient() {
    const { notifyError } = useToastContext();

    function handleError(error: unknown) {
        notifyError("Error Occurred");
    }

    async function authFetch(path: string, request?: RequestInit) {
        try {
            if (!request) {
                request = {
                    method: "GET"
                };
            }

            request.credentials = "include";
            request.mode = "cors";

            const res = await fetch(path, request);
            if (res.ok) {
                return res;
            }
            const resRefresh = await refresh();
            if (resRefresh.status === 401) {
                window.location.href = window.location.origin + "/p/signed-out";
            }
            return await fetch(path, request);
        } catch (e) {
            handleError(e);
            throw e;
        }
    }

    async function refresh() {
        const ps = {
            credentials: "include",
            method: "GET",
            mode: "cors"
        } as RequestInit;
        return fetch(API_URL + "/auth/refresh", ps).then();
    }

    function signOut() {
        window.location.href = AUTH_URL + "/auth/logout";
    }

    function signIn() {
        window.location.href =
            AUTH_URL +
            "/auth/login?redirectUri=" +
            encodeURIComponent(window.location.origin);
    }

    async function profile(): Promise<User | null> {
        const path = API_URL + "/auth/profile";
        const request = {
            credentials: "include",
            method: "GET",
            mode: "cors"
        } as RequestInit;
        const res = await fetch(path, request);
        if (res.ok) {
            return await res.json();
        }

        const resRefresh = await refresh();
        if (resRefresh.status === 401) {
            signIn();
            return null;
        }

        const res2 = await fetch(path, request);
        return await res2.json();
    }

    return {
        authFetch,
        refresh,
        signOut,
        signIn,
        profile
    };
}
